module.exports = __webpack_public_path__ + "fontawesome-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 1719
// module chunks = 11